import Model from '@/lib/data/Model';

class RiskForm extends Model {
    fields = [
        'GW',
        'MGW',
        'max_point',
        'name',
        'section',
        'type',
        {
            name: 'percent',
            type: 'float',
            getter(v) {
                return Math.floor(v * 10000) / 100;
            },
        },
    ];

    /**
     * Create the RiskForm object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }
}

export default RiskForm;
